<template>
  <div class="right-nav cust-home-nav gap-md-3 gap-2">

    <!-- Search button -->
    <div class="right-nav-btns d-block"
      v-if="this.$route.name == 'home' || this.$auth.setting && this.$auth.setting.is_vendor_listing == false">
      <router-link class="icon-btn" to="/search">
        <span class="stash--search-solid | theme_ic"></span>
      </router-link>
    </div>

    <!-- Promo code button -->
    <div class="right-nav-btns"
      v-if="$route.path !== '/payment' && !is_mobile_screen && $route.path !== '/review-cart'">
      <button class="icon-btn" @click="promocodeModal">
        <span class="lineicons--badge-decagram-percent | theme_ic"></span>
      </button>
    </div>

    <!-- PWA Install button - Updated conditions -->
    <div class="right-nav-btns" v-if="shouldShowInstallButton">
      <button class="icon-btn" @click="installPWA">
        <span class="ic--round-install-mobile | theme_ic"></span>
      </button>
    </div>

    <!-- Language switcher -->
    <div class="switch-lang" v-if="languageArray.length > 1">
      <div class="current-lang">
        <span class="clarity--language-solid | theme_ic"></span>
        <p class="lang-text d-none d-md-block">{{ $store.state.lang.locale }}</p>
      </div>
      <div class="lang-dropdown">
        <div class="selecting-lang" @click="swichLanguage(lang.value)" v-for="(lang, i) in languageArray" :key="i">
          <p class="lang-text">{{ lang.text }}</p>
          <i class="fa fa-check" aria-hidden="true" v-if="lang.value == $store.state.lang.locale"></i>
        </div>
      </div>
    </div>

    <!-- Profile icon -->
    <div class="profil-image">
      <router-link :to="getRedirectPath()" class="icon-btn">
        <span class="iconamoon--profile-circle-light | theme_ic"></span>
      </router-link>
    </div>

    <!-- Cart icon -->
    <div v-if="$route.path !== '/payment' && $route.path !== '/review-cart' && $route.path !== '/sign-in'">
      <form class="form-inline menu-links my-2 my-md-0" v-for="link in links" :key="link.title">
        <div class="search-cart d-flex align-items-center gap-md-4 gap-2">
          <a href="#" class="form-group has-search mb-0 icon-btn" data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
            <div class=" d-flex align-items-center position-relative">
              <span class="solar--cart-large-2-outline | theme_ic"></span>
              <span class="mbl-crt-cart cartCount cart-badge" v-if="link.cartItemCount && cart.length > 0">
                {{cart.length > 0 ? cart.reduce((a, c) => (a + c.quantity), 0) : ""}}
              </span>
            </div>
          </a>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getLanguageText } from '../helper/helper';

export default {
  data() {
    return {
      links: [
        {
          title: this.$t("Cart"),
          icon: require('@/assets/images/cart.svg'),
          cartItemCount: '0',
          url: 'review-cart',
        },
      ],
      languageArray: [],
      // PWA related data
      deferredPrompt: null,
      isIOS: /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream,
      isSafari: /^((?!chrome|android).)*safari/i.test(navigator.userAgent),
      isStandalone: window.matchMedia('(display-mode: standalone)').matches ||
        (navigator.standalone === true),
      isMobile: window.innerWidth < 1024,
    };
  },
  computed: {
    ...mapGetters("product", ["cart"]),
    shouldShowInstallButton() {
      // Don't show if already in standalone mode
      if (this.isStandalone) return false;
      // Show on mobile devices only
      if (!this.isMobile) return false;
      // For iOS/Safari, check if it's not already installed
      if (this.isIOS) {
        return !this.isStandalone;
      }
      // For Android/other browsers, show if we have a deferred prompt
      return this.deferredPrompt !== null;
    }
  },

  mounted() {
    this.setupPWAInstallPrompt();
    setTimeout(() => {
      if (this.$auth.setting) {
        this.languageArray = [{ 'value': this.$auth.setting.primary_lang, text: getLanguageText(this.$auth.setting.primary_lang) }];
        if (this.$auth.setting && this.$auth.setting.primary_lang == this.$auth.setting.secondary_lang) {
          this.languageArray = [{ 'value': this.$auth.setting.primary_lang, text: getLanguageText(this.$auth.setting.primary_lang) }];
        }
        if (this.$auth.setting.secondary_lang) {
          this.languageArray.push({ 'value': this.$auth.setting.secondary_lang, text: getLanguageText(this.$auth.setting.secondary_lang) });
        }
      }
    }, 1000);
  },

  methods: {
    getLanguageText,
    swichLanguage(lang) {
      localStorage.setItem('localelang', lang);
      this.$store.dispatch('lang/changeLangLocale', lang);
      window.location.reload();
    },

    getRedirectPath() {
      return this.$auth.user ? { name: 'profile' } : { name: 'sign-in' };
    },

    toggleButton() {
      this.$emit("toggleCart", 'yes');
    },

    promocodeModal() {
      this.$emit("procodeOpenModal", 'yes');
    },

    // pwa start  point
    setupPWAInstallPrompt() {
      // Listen for the beforeinstallprompt event (Android/Chrome)
      window.addEventListener("beforeinstallprompt", (e) => {
        e.preventDefault();
        this.deferredPrompt = e;
      });

      // Detect when the app is already installed
      window.addEventListener("appinstalled", () => {
        this.deferredPrompt = null;
      });

      // For iOS, we need to check if it's capable of being installed
      // iOS doesn't have a standard event, so we rely on other indicators
      if (this.isIOS) {
        // Check if it's not already installed and meets PWA criteria
        const isEligibleForPWA =
          window.navigator.standalone !== true &&
          document.referrer.includes('applewebdata') === false;

        if (isEligibleForPWA) {
          // iOS can support PWAs, so we'll show the install button
          console.log("iOS device eligible for PWA installation");
        }
      }
    },

    async installPWA() {
      // Handle Android/Chrome installation
      if (this.deferredPrompt) {
        try {
          this.deferredPrompt.prompt();
          const { outcome } = await this.deferredPrompt.userChoice;

          if (outcome === 'accepted') {
            console.log('User accepted the install prompt');
          } else {
            console.log('User dismissed the install prompt');
          }

          this.deferredPrompt = null;
        } catch (error) {
          console.error('Error during installation:', error);
        }
        return;
      }

      // Handle iOS installation instructions
      if (this.isIOS) {
        this.showIOSInstallInstructions();
        return;
      }

      // Generic fallback for other browsers
      this.showGenericInstallInstructions();
    },

    showIOSInstallInstructions() {
      // Create a more user-friendly iOS instruction modal
      this.$swal({
        title: this.$t("Install App"),
        html: this.$t('<div>click on <span class="ion--share-outline"> </span> <strong>"Add to Home Screen"</strong> from the browser menu and shourtcut for easy access</div>'),
        iconHtml: '<span class="ic--round-install-mobile | theme_ic download-icon"></span>',
        confirmButtonText: this.$t('Got it!'),
        customClass: {
          icon: 'custom-swal-icon',   // ✅ apply custom class on icon container
          popup: 'custom-swal-popup'  // (optional, if you want styling on popup itself)
        }
      });
    },

    showGenericInstallInstructions() {
      const userAgent = navigator.userAgent.toLowerCase();
      let message = "";

      if (userAgent.includes('firefox')) {
        message = this.$t("Tap the menu button and select 'Install'");
      } else if (userAgent.includes('samsung')) {
        message = this.$t("Tap the menu button and select 'Add page to' then 'Home screen'");
      } else {
        message = this.$t("Look for the 'Install' or 'Add to Home Screen' option in your browser menu");
      }

      this.$swal({
        title: this.$t("Install App"),
        text: message,
        icon: 'info',
        confirmButtonText: this.$t('OK')
      });
    },
    // pwa end point
  }
};
</script>
